import React from 'react'
import { MOBILE_SIZE } from '../../../../core/constants/common'
import { useWindowSize } from '../../../../modules/Dashboard'
import MobileModal from '../../../../components/layouts/MobileModal'
import AnalyzerLoading from './Main'
import ModalLayout from '../../../../components/layouts/ModalLayout'

const AILoading = ({ loading }) => {
    const { width } = useWindowSize()
    return (
        <>
            {
                width <= MOBILE_SIZE ?
                    <MobileModal isOpen={loading} onClose={() => { }} noPadding>
                        <AnalyzerLoading loading={loading} />
                    </MobileModal>
                    :
                    <ModalLayout padding={"0"} width={"630px"} open={loading} onClose={() => { }}>
                        <AnalyzerLoading loading={loading} />
                    </ModalLayout>
            }
        </>
    )
}

export default AILoading